import { appEnvPrefix, isProductionEnv } from 'shared/helpers/general'

export function getLivingBaseUrl(domain, appVariant) {
  if (isProductionEnv()) {
    return appVariant ? `https://living-widget.sparx.ai?variant=${appVariant}` : `https://${domain}?`
  } else {
    const env = appEnvPrefix()
    return appVariant ? `https://living-widget-${env}.sparx.ai?variant=${appVariant}` : `https://${domain}?`
  }
}

export function getLivingWidgetUrl(baseUrl, params) {
  return `${baseUrl}${params && Object.keys(params).length > 0 ? `&${new URLSearchParams(params).toString()}` : ''}`
}